module.exports = __webpack_public_path__ + "img/icon_refresh.2a7e8904.svg";